/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  function waitForElm(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          observer.disconnect();
          resolve(document.querySelector(selector));
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  /* Updates tag list order on product list items */
  function updateTagSpecs() {
    const specLists = document.querySelectorAll('.product-tags');
    const specOrder = ['gpu', 'cpu', 'memory', 'storage'];
  
    specLists.forEach(function(ul) {
      const specListItems = Array.from(ul.querySelectorAll('li'));
      
      specListItems.sort(function(a, b) {
        const specA = a.querySelector('img').getAttribute('alt').toLowerCase();
        const specB = b.querySelector('img').getAttribute('alt').toLowerCase();
        return specOrder.indexOf(specA) - specOrder.indexOf(specB);
      });
  
      specListItems.forEach(function(li) {
        ul.removeChild(li);
      });
  
      specListItems.forEach(function(li) {
        ul.appendChild(li);
      });
    });

    const brandLogoLists = document.querySelectorAll('.brand-logos');
    const brandOrder = ['amd logo', 'intel logo', 'nvidia logo'];
  
    brandLogoLists.forEach(function(ul) {
      const brandItems = Array.from(ul.querySelectorAll('li'));
      
      brandItems.sort(function(a, b) {
        const brandItemA = a.querySelector('img').getAttribute('alt').toLowerCase();
        const brandItemB = b.querySelector('img').getAttribute('alt').toLowerCase();
        return brandOrder.indexOf(brandItemA) - brandOrder.indexOf(brandItemB);
      });
  
      brandItems.forEach(function(li) {
        ul.removeChild(li);
      });
  
      brandItems.forEach(function(li) {
        ul.appendChild(li);
      });
    });
  }
 
  document.addEventListener("DOMContentLoaded", function() {

    window.updateTagSpecs = updateTagSpecs;

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    
    /* Updates tag list order on product list items */
    updateTagSpecs();
    
    /* Also when changing filters at Collection page */
    const collectionContainer = document.querySelector('[data-products-grid]');

    if (collectionContainer) {
      const collectionObserver = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (!collectionContainer.className.includes('is-loading')) {
              updateTagSpecs();
            }
          }
        });
      });
  
      collectionObserver.observe(collectionContainer, { attributes: true });
    }    

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /* Shows/hides RTS Badge when un-checking default version for a specific product */
    // const selectedProduct = document.querySelector('[name="id"]');
    const selectedProduct = document.querySelector('[data-option-value]');
    // const rtsProducts = [
    //   'better-gaming-pc-intel-core-i7-nvidia-rtx-4070-super',
    // ];
    const rtsVariants = [
      '52377061097836', // Good Intel variant ID
      '52377096225132', // Better Intel variant ID
    ];

    const isRTSProduct = document.querySelector('.rts--tag');
    
    if (selectedProduct && isRTSProduct) {
      // Is in an RTS product page
      if (window.location.pathname.includes('good-intel-intel-core-i5-14400f-nvidia-rtx-5060') || window.location.pathname.includes('better-intel-intel-core-i7-13700f-nvidia-rtx-5070')) {
        const toggleRTS = (isRTS, showModal) => {          
          if (isRTSProduct) {
            const visibilityVal = isRTS ? 'visible' : 'hidden';
            isRTSProduct.style.visibility = visibilityVal;
          }
          if (showModal) {
            Fancybox.show([{ src: "#rts-alert", type: "inline" }]);
          }
        };
        const getSelectedVariant = () => document.querySelector('[name="id"]') ? document.querySelector('[name="id"]').value : '';
        
        // First run
        toggleRTS(rtsVariants.includes(getSelectedVariant()));

        // On changing variants
        const specificProdObserver = new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
            toggleRTS(rtsVariants.includes(getSelectedVariant()), !rtsVariants.includes(getSelectedVariant()));
          });
        });
    
        specificProdObserver.observe(selectedProduct, { childList: true });
      }
    }
    
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /* Adds selling points to the index hero section */

    const indexHeroSection = document.querySelector('.template-index .section-overlay-header');
    
    if (indexHeroSection) {
      const indexHeroText = indexHeroSection.querySelector('.hero__description');
      // const indexHeroText = indexHeroSection.querySelector('.hero__title');
      if (indexHeroText) {
        const sellFeatList = document.createElement('ul');
        sellFeatList.classList.add('sell-feat-list');
        const sellFeatListItem = document.createElement('li');
        
        const sellFeatTitles = document.querySelectorAll('.column__heading.heading-small');
        const sellFeatImgs = document.querySelectorAll('.icon__animated');

        sellFeatImgs.forEach((img, index) => {
          const sellFig = img.childNodes[0].cloneNode(true);
          const sellTitle = document.createTextNode(sellFeatTitles[index].innerText.replace('Gaming ', ''));

          const liNode = sellFeatListItem.cloneNode();
          liNode.appendChild(sellFig);
          liNode.appendChild(sellTitle);

          if (index < 2) {
            sellFeatList.appendChild(liNode);
          }
        });

        //indexHeroText.insertAdjacentElement("afterend", sellFeatList);

        /* Adds image to index subtitle and new paragraph */

        // const figureHTMLString = `        
        //   <img src="//www.buildredux.com/cdn/shop/files/competitive-price.webp?crop=center&amp;height=35&amp;v=1728503730&amp;width=35" width="35" height="35" loading="lazy" srcset="//www.buildredux.com/cdn/shop/files/competitive-price.webp?v=1728503730&amp;width=35 35w, //www.buildredux.com/cdn/shop/files/competitive-price.webp?v=1728503730&amp;width=70 70w" sizes="35px" style="vertical-align: sub;"> 
        // `;
        
        // indexHeroText.querySelector('p:first-child').insertAdjacentHTML('afterbegin', figureHTMLString);

      }
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    
    /* Adds logo for MS section on product page */

    const msBlockElement = document.querySelector('.template-product main > div:last-of-type');
    
    if (msBlockElement) {
      const msHeading = msBlockElement.querySelector('.hero__subheading');
      if (msHeading) {
        const imgMsLogo = document.createElement('img');
        imgMsLogo.src = 'https://cdn.shopify.com/s/files/1/0408/5792/7834/files/windows-logo-white.webp?v=1729636379';
        imgMsLogo.width = 34;
        imgMsLogo.alt = 'Microsoft Windows 11 Logo';
        imgMsLogo.style.verticalAlign = 'middle';
        imgMsLogo.style.marginRight = '8px';
        msHeading.prepend(imgMsLogo);
      }
    }
        
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    const isProductPage = document.body.classList.contains('template-product');

    if (isProductPage) {

      /* Maps and gives a idenfying class for all product page sections for ease of handling */

      const prodPageSectionMap = {
        0: 'breadcrumbs',
        1: 'product-info',
        2: 'ul-fps',
        3: 'two-videos',
        4: 'selling-points',
        5: 'gaming-performance',
        6: 'nvidia-40-section',
        7: 'nvidia-40-section',
        8: 'nvidia-40-section',
        9: 'nvidia-50-section',
        10: 'nvidia-50-section',
        11: 'nvidia-50-section',
        12: 'intel-section',
        13: 'intel-section',
        14: 'amd-section',
        15: 'amd-section',
        16: 'microsoft-section',
      };
      
      const prodPageSections = document.querySelectorAll('main > div');

      prodPageSections.forEach((section, index) => {
        section.classList.add('pdp_' + prodPageSectionMap[index]);
      });
      
      const intelSpecificSelectors = document.querySelectorAll('.pdp_intel-section');
      const amdSpecificSelectors = document.querySelectorAll('.pdp_amd-section');
      const nvidia40Selectors = document.querySelectorAll('.pdp_nvidia-40-section');
      const nvidia50Selectors = document.querySelectorAll('.pdp_nvidia-50-section');

      /* Removes brand-specific sections from non-present components at product page */
      
      const isIntel = document.querySelector('[data-prod-cpu="intel"]');
      const isAmd = document.querySelector('[data-prod-cpu="amd"]');

      const isNvidia40 = document.querySelector('.prod-component-list > li:nth-child(1) > span').innerText.includes('RTX 40');
      const isNvidia50 = document.querySelector('.prod-component-list > li:nth-child(1) > span').innerText.includes('RTX 50');
      
      const removeElements = arrElements => {
        arrElements.forEach(element => {
          element.parentNode.removeChild(element);
        });    
      }
      
      if (isIntel) {
        removeElements(amdSpecificSelectors);
      } else if (isAmd) {
        removeElements(intelSpecificSelectors);
      }

      if (isNvidia40) {
        removeElements(nvidia50Selectors);
      } else if (isNvidia50) {
        removeElements(nvidia40Selectors);
      }

      ///////////////////////////////

      // Replaces Bread Button innerText with HTML for customizing underline behavior
      
      try {
        waitForElm('.template-product .bread-btn-class a').then((aBtn) => {
          const [part1, part2] = aBtn.innerText.split(" $");
        
          aBtn.innerHTML = '';
        
          const spanTemplate = document.createElement('span');
        
          const span1 = spanTemplate.cloneNode();
          span1.textContent = `${part1} `;
          aBtn.appendChild(span1);
        
          const span2 = spanTemplate.cloneNode();
          span2.textContent = `$${part2}`;
          aBtn.appendChild(span2);
        });
      } catch (error) {
        console.error(error);
      }

      ////////////////////////////////

      // End of "is Product Page" 
      
    }

    
    
    // const intelElementSelectors = ['.template-product main > div:nth-child(8)', '.template-product main > div:nth-child(8)'];

    // const amdElementSelectors = ['.template-product main > div:nth-child(10)', '.template-product main > div:nth-child(10)'];

    // const nvidia4000ElementSelectors = ['.template-product main > div:nth-child(5)','.template-product main > div:nth-child(7)','.template-product main > div:nth-child(8)'];
    // const nvidia5000ElementSelectors = ['.template-product main > div:nth-child(9)','.template-product main > div:nth-child(10)','.template-product main > div:nth-child(11)'];
  
    // const isIntel = document.querySelector('[data-prod-cpu="intel"]');
    
    // const isAmd = document.querySelector('[data-prod-cpu="amd"]');
    
    // const removeElements = arrElements => {
    //   arrElements.forEach(element => {
    //     const el = document.querySelector(element);
    //     el.parentNode.removeChild(el);
    //   });    
    // }
    
    // if (isIntel) {
    //   removeElements(amdElementSelectors);
    // } else if (isAmd) {
    //   removeElements(intelElementSelectors);
    // }
    
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /* Gets current product and variant price difference ($X OFF) */
    function getProdPriceDiff() {
      const oldPrice = Number(document.querySelector('s.price-item.price-item--regular').innerText.replace(/\D/g,''));
      const newPrice = Number(document.querySelector('.price-item.price-item--sale.price-item--last').innerText.replace(/\D/g,''));
      
      return (oldPrice - newPrice);
    }

    /* Places diff tags in their corresponding spots */
    function placeDiffTags() {
      const priceDiffTag = document.querySelector('.price--diff-tag');
    
      if (!priceDiffTag) {
        return false;
      }   
      
      const finalText = `$${getProdPriceDiff()} OFF`;
      
      priceDiffTag.innerText = finalText;
  
      const diffTagSibblings = ['.cart-bar [data-price-wrapper]', '.product__content .price--on-sale .price__sale'];
  
      diffTagSibblings.forEach(tagSibbling => {
        const element = document.querySelector(tagSibbling);
  
        if (element) {
          const clonedTag = priceDiffTag.cloneNode(true);
          clonedTag.setAttribute('data-placed-diff-tag', true);
          element.insertAdjacentElement("afterend", clonedTag);
          clonedTag.style.display = 'inline-flex';
        }
      });      
    }

    /* Updates price difference tag ($X OFF) */
    function updatePriceDiffTags() {
      const priceDiffTags = document.querySelectorAll('[data-placed-diff-tag]');
    
      if (!priceDiffTags.length) {
        return false;
      }
    
      const finalText = `$${getProdPriceDiff()} OFF`;
      
      priceDiffTags.forEach(priceDiffTag => {
        priceDiffTag.innerText = finalText;    
      });      
    }

    /* Updates storage and memory components data according to selected variant */
    function updateSpecsFromVariant() {
      const extractMemoryAndStorage = str => {
        const memoryRegex = /(\d+GB)\sMemory/;
        const storageRegex = /(\d+TB)\sStorage/;        
        
        const memoryMatch = str.match(memoryRegex);
        const storageMatch = str.match(storageRegex);
        
        const memory = memoryMatch ? memoryMatch[1] : null;
        const storage = storageMatch ? storageMatch[1] : null;
        
        return { memory, storage };
      }

      const variantElement = document.querySelector('[data-option-value]');

      if (!variantElement) {
        return false;
      }
      
      const currentVariationData = variantElement.innerText;

      const { memory, storage } = extractMemoryAndStorage(currentVariationData);

      const memoryElement = document.querySelector('[data-memory-amount]');
      const storageElement = document.querySelector('[data-storage-amount]');

      if (memoryElement) {
        memoryElement.innerText = memory;
      }
      if (storageElement) {
        storageElement.innerText = storage;
      }
    }    

    placeDiffTags(); // places all "price-diff" tags "ex: ($100 OFF)"
    updateSpecsFromVariant(); // updates component list according to initially selected variant
    
    const selectedProdVariation = document.querySelector('[data-option-value]');
    
    function handleMutation(mutationsList, observer) {
      mutationsList.forEach(mutation => {
        if (mutation.type === 'childList') {
          updatePriceDiffTags();
          updateSpecsFromVariant();
        }
      });
    }
    
    const observer = new MutationObserver(handleMutation);
    const config = {
      attributes: false,
      childList: true,
      subtree: false,
      characterData: false
    };
    
    if (selectedProdVariation) {
      observer.observe(selectedProdVariation, config);
    } else {
      if (observer) {
        // Stop observing element
        observer.disconnect();
      }
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    
    
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /* Forcibly replaces 'Add to cart' button for NVIDIA RTX 50 Series products, for using Klavio button*/
    if (isProductPage) {
      const btnAddToCart = document.querySelector('[data-add-to-cart]');
      const tempReplaceBtn = document.querySelector('#temp-cta-replace');
      if (tempReplaceBtn) {
        tempReplaceBtn.addEventListener('pointerup', () => {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'WN2pr6']);
        });

        btnAddToCart.replaceWith(tempReplaceBtn);
      }
                 
    }

    /* Forcibly updates 'Add to cart' wording to 'Add to Cart', in order to match desired communication */
    // const addToCartTexts = document.querySelectorAll('[data-add-to-cart-text]') ?? [];
    // addToCartTexts.forEach(addToCartText => addToCartText.innerText = 'Add to Cart');

    /* Forcibly preserves 'Pre-order now' on buttons, as they're post-changed to "Add to cart" by vendors.js */    
    // const longerETAElements = document.querySelectorAll('[data-longer-eta]') ?? [];
    // longerETAElements.forEach(longerETAEl => {
    //   longerETAEl.innerText = 'Pre-order now';
    // });

    /* Forcibly removes "+" sign from variants texts on mobile */
    if (window.innerWidth < 515) {
      const variantsTexts = document.querySelectorAll('span.option-title') ?? [];
      variantsTexts.forEach(variantsText => variantsText.innerText = variantsText.innerText.replace('+', '\n'));
    }
    

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /* Adds RD to the order lookup field */
    const populateEmail = document.querySelector('.populate-email') ? document.querySelector('.populate-email').innerText : '';
    const populateOrder = document.querySelector('.populate-order') ? document.querySelector('.populate-order').innerText : '';

    waitForElm('#order-lookup-form').then((elm) => {
      const orderLookupWrapper = document.querySelector('.w3-order-lookup');
      const fieldOrderNum = document.querySelector('#order-lookup-form #orderNumber');
      const fieldOrderMail = document.querySelector('#order-lookup-form #emailAddress');
      setTimeout(() => {
        if (orderLookupWrapper) {
          orderLookupWrapper.classList.remove('loading');
        }
        if (fieldOrderNum) {
          fieldOrderNum.value = 'RD' + populateOrder;
        }
        if (fieldOrderMail) {
          fieldOrderMail.value = populateEmail;
        }
        // $('#findOrder').click();
      }, 0);
    });
    
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  });

  
  /* Auto-clicks "load more" whenever oke-showmore-button is present */
  window.addEventListener("load", function () {
    const okeRoutes = ['why-redux', 'reviews', 'gaming-computers/products'];
    const hasOke = okeRoutes.filter(item => window.location.pathname.includes(item)).length > 0;
    if (hasOke) {
      setTimeout(() => {
        waitForElm('.oke-showMore-button').then((elm) => {
          const observer = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                  if (entry.isIntersecting) {
                      elm.click();
                  }
              });
          });
          observer.observe(elm);
        });
      }, 1000);
    }
  });
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

Fancybox.bind("[data-fancybox]", {});
